import ng from 'angular';
import { IWorkflowAcao } from '../../models/workflow.acao.model';
import { IColaboradorWorkflow } from '../../models/workflow.colaborador.model';

export class WorkflowDefaultModalController implements ng.IController {

    static $inject = [
        'acao',
        'trabalhador',
        '$uibModalInstance'
    ];

    constructor(
        public acao: IWorkflowAcao,
        public trabalhador: IColaboradorWorkflow,
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
    ) {
        this.tratarTextosModal();
    }

    public confirmar(): void {
        this.$uibModalInstance.close(this.acao);
    }

    public close(): void {
        this.$uibModalInstance.dismiss('fechar');
    }

    private tratarTextosModal(): void {
        this.tratarNomeColaborador(this.acao.modal!.confirmacao!.textos);
    }

    private tratarNomeColaborador(textos: string[]): void {
        const nome: string = this.trabalhador?.nome ?? '';

        textos.forEach((texto: string, index: number) => {
            const textoModificado: string = texto.replace(/\{\{nome_colaborador\}\}/g, () => nome);
            textos[index] = textoModificado;
        });
    }
}
